const data = {
  title: 'An award-winning team to support you',
  subtitle:
    'Our award-winning funeral directors are here 7 days a week to support you through the process. We believe everyone deserves a send-off as unique as they are, without compromising on cost, or quality.',
  subtitle2: 'A direct cremation is 80% cheaper than the average UK funeral.',
}

export default data
